var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRedcross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.0449 12.5505C0.362639 13.2328 0.362636 14.339 1.0449 15.0212C1.72716 15.7035 2.83333 15.7035 3.51559 15.0212L8.03312 10.5037L12.5506 15.0212C13.2329 15.7035 14.3391 15.7035 15.0213 15.0212C15.7036 14.339 15.7036 13.2328 15.0213 12.5506L10.5038 8.03302L15.0212 3.51559C15.7035 2.83333 15.7035 1.72716 15.0212 1.0449C14.339 0.362637 13.2328 0.362638 12.5505 1.0449L8.03312 5.56233L3.51569 1.0449C2.83342 0.362639 1.72726 0.362637 1.04499 1.0449C0.36273 1.72716 0.36273 2.83333 1.04499 3.51559L5.56243 8.03302L1.0449 12.5505Z",
    fill: "#E5704C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRedcross);
export default __webpack_public_path__ + "static/media/icon_redcross.8f0c81ec63ed5761ad13c3d91ca6c975.svg";
export { ForwardRef as ReactComponent };